import React, { memo } from 'react'
import { useDispatch } from 'react-redux'

const useFetchData = memo(({ url, Data, method }) => {
    if (!url) throw new Error("url is required")
    const dispatch = useDispatch()
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const fetchData = async () => {
        try {
            setLoading(true)
            const urlData = {
                ...Data
            }
            const data = await hook.useAxios({ url, "data": urlData, method, dispatch })
            setData(data)
        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }
    React.useEffect(() => {
        fetchData()
    }, [])
    return {
        data, loading, fetchData, error
    }
})

export default useFetchData